import { CommandParameterDTO, CommandParametersType } from '@types'

export const getStateFromData = (
  data: CommandParameterDTO[] | undefined
): CommandParametersType[] => {
  if (!data?.length) {
    return []
  }

  return data.map(param => {
    return {
      id: param.id,
      title: param.title
        ? {
            id: param.title,
            label: param.title,
          }
        : null,
      type: param.type
        ? {
            id: param.type,
            label: param.type.toLowerCase(),
          }
        : null,
      objectCode: param.objectCode
        ? {
            id: param.objectCode,
            label: param.objectTitle || param.objectCode,
          }
        : null,
      value: param.value,
      pathArray: param.pathArray,
    }
  })
}
